import React from "react";
import { TermsOfUse } from "../../components/Navigation/Privacy/TermsOfUse";
import "../legal/style.css";

export const TermsOfUsePage = () => {
    return (
        <div className="legal-page">
            <header className="legal-page-header">
                <a className="legal-page-brand" href="/app">
                    <span className="legal-page-brand-text">Calo</span>
                </a>
                <div className="legal-page-links">
                    <a href="/app">App Homepage</a>
                    <a href="/privacy-policy">Privacy Policy</a>
                </div>
            </header>

            <main className="legal-page-main">
                <div className="legal-page-title">
                    <p className="legal-page-eyebrow">Legal</p>
                    <h1>Terms of Use</h1>
                    <p>
                        These terms describe how users may access and use the Calo mobile
                        application and related services.
                    </p>
                </div>
                <div className="legal-page-content">
                    <TermsOfUse />
                </div>
            </main>
        </div>
    );
};
